export default __webpack_public_path__ + "static/media/NON-GMO.e4199ec6.png";